import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getProfileId } from '@/utils/profile';
import { profileDetailsRoute } from './configRoute/profile/profileDetails.route';
import { profileEditRoute } from './configRoute/profile/profileEdit.route';

export const myProfileRoute: RouteConfig = {
  path: 'profile',
  component: () => import(/* webpackChunkName: "Profile" */ '@/views/mainRoute/profile/Profile.vue'),
  children: [profileDetailsRoute('myProfile'), profileEditRoute('myProfileEdit')],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'Profil',
      name: 'myProfile'
    }
  },
  props: {
    tabs: [
      {
        title: 'Profil',
        route: { name: 'myProfile' },
        permissions: ['USER.GET']
      },
      {
        title: 'Edycja',
        route: { name: 'myProfileEdit' },
        permissions: ['USER.UPDATE']
      }
    ]
  },

  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('profile/setId', getProfileId());
    store
      .dispatch('profile/get')
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.PROFILE_CANNOT_GET }));
  }
};
